import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 67.798 77.483',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      className="icon"
      d="M0,70.219a7.266,7.266,0,0,0,7.264,7.264h53.27A7.266,7.266,0,0,0,67.8,70.219V29.056H0ZM48.427,40.557a1.821,1.821,0,0,1,1.816-1.816H56.3a1.821,1.821,0,0,1,1.816,1.816v6.053A1.821,1.821,0,0,1,56.3,48.427H50.243a1.821,1.821,0,0,1-1.816-1.816Zm0,19.371a1.821,1.821,0,0,1,1.816-1.816H56.3a1.821,1.821,0,0,1,1.816,1.816v6.053A1.821,1.821,0,0,1,56.3,67.8H50.243a1.821,1.821,0,0,1-1.816-1.816ZM29.056,40.557a1.821,1.821,0,0,1,1.816-1.816h6.053a1.821,1.821,0,0,1,1.816,1.816v6.053a1.821,1.821,0,0,1-1.816,1.816H30.872a1.821,1.821,0,0,1-1.816-1.816Zm0,19.371a1.821,1.821,0,0,1,1.816-1.816h6.053a1.821,1.821,0,0,1,1.816,1.816v6.053A1.821,1.821,0,0,1,36.925,67.8H30.872a1.821,1.821,0,0,1-1.816-1.816ZM9.685,40.557A1.821,1.821,0,0,1,11.5,38.741h6.053a1.821,1.821,0,0,1,1.816,1.816v6.053a1.821,1.821,0,0,1-1.816,1.816H11.5a1.821,1.821,0,0,1-1.816-1.816Zm0,19.371A1.821,1.821,0,0,1,11.5,58.112h6.053a1.821,1.821,0,0,1,1.816,1.816v6.053A1.821,1.821,0,0,1,17.555,67.8H11.5a1.821,1.821,0,0,1-1.816-1.816ZM60.534,9.685H53.27V2.421A2.428,2.428,0,0,0,50.848,0H46.005a2.428,2.428,0,0,0-2.421,2.421V9.685H24.213V2.421A2.428,2.428,0,0,0,21.792,0H16.949a2.428,2.428,0,0,0-2.421,2.421V9.685H7.264A7.266,7.266,0,0,0,0,16.949v7.264H67.8V16.949A7.266,7.266,0,0,0,60.534,9.685Z"
      fill={fill}
    />
  </svg>
);

export default SVG;
